import type { SocketNamespace } from '@/types';
import { useNamespaceSocket } from '@/contexts/SocketContext';
import { Socket } from 'socket.io-client';

/**
 * Hook to get a socket connection for a specific namespace
 * This now uses the SocketContext for centralized socket management
 */
export function useSocket(namespace: SocketNamespace): Socket | null {
  const { socket } = useNamespaceSocket(namespace);
  return socket ?? null;
}
